import axios from 'axios';
import UserAuthKey from '../../../components/Common/UserAuthKey';
import { setUserData } from '../../../Redux/user/userSlice';
import {
  setListLoading,
  setPaymentFailedOrders,
  setListError,
  setDetailLoading,
  setPaymentFailedOrderDetail,
  setSummaryLoading,
  setPaymentFailedOrdersSummary,
  setExporting,
} from '../../../Redux/paymentFailedOrders/paymentFailedOrdersSlice';

const apiUrl = process.env.REACT_APP_OMS_API;

const authHeaders = () => ({
  Authorization: `Bearer ${UserAuthKey()}`,
  'Content-Type': 'application/json',
});

const isAuthError = (error, dispatch) => {
  if (error?.response?.status === 401) {
    if (dispatch) dispatch(setUserData(null));
    window.location.replace('/logout');
    return true;
  }
  return false;
};

const post = (path, data) =>
  axios({
    method: 'POST',
    url: `${apiUrl}v1/payment-failed-orders/${path}`,
    headers: authHeaders(),
    data,
  });

/**
 * POST v1/payment-failed-orders/list
 * body: { page, per_page, search, action_status: [], trigger_reason, country,
 *         payment_mode, payment_failure_reason, date_from, date_to, record_state }
 * response: { code, data: { data: [rows], recordsTotal } }
 */
export const fetchPaymentFailedOrders = async ({ params, dispatch }) => {
  try {
    dispatch(setListLoading(true));
    const response = await post('list', params);
    dispatch(setPaymentFailedOrders(response?.data));
    return response.data;
  } catch (error) {
    if (!isAuthError(error, dispatch)) {
      dispatch(setListError(error?.response?.data?.message));
    }
    throw error;
  }
};

/**
 * POST v1/payment-failed-orders/details
 * body: { id }
 * response: { code, data: { ...record, history: [{ action_status, remarks,
 *            updated_by_username, created_at }] } }
 */
export const fetchPaymentFailedOrderDetail = async ({ params, dispatch }) => {
  try {
    dispatch(setDetailLoading(true));
    const response = await post('details', params);
    dispatch(setPaymentFailedOrderDetail(response?.data));
    return response.data;
  } catch (error) {
    dispatch(setDetailLoading(false));
    if (!isAuthError(error, dispatch)) {
      throw error;
    }
  }
};

/**
 * POST v1/payment-failed-orders/update-action
 * body: { id, action_status, remarks, resolved_order_no, oms_user_id,
 *         updated_by_username }
 * The API writes the history row and stamps closed_at for the closing statuses.
 */
export const updatePaymentFailedOrderAction = async ({ params, dispatch }) => {
  try {
    const response = await post('update-action', params);
    return response.data;
  } catch (error) {
    if (!isAuthError(error, dispatch)) {
      throw error;
    }
  }
};

/**
 * POST v1/payment-failed-orders/summary
 * body: same filters as list (without pagination)
 * response: { code, data: { total, converted, not_converted, open,
 *            conversion_rate, revenue_recovered, currency } }
 */
export const fetchPaymentFailedOrdersSummary = async ({ params, dispatch }) => {
  try {
    dispatch(setSummaryLoading(true));
    const response = await post('summary', params);
    dispatch(setPaymentFailedOrdersSummary(response?.data));
    return response.data;
  } catch (error) {
    dispatch(setSummaryLoading(false));
    if (!isAuthError(error, dispatch)) {
      throw error;
    }
  }
};

/**
 * POST v1/payment-failed-orders/export
 * body: the current filters, unpaginated
 * response: { code, data: { data: [rows], summary: {...} } } or { data: [rows] }
 */
export const exportPaymentFailedOrders = async ({ params, dispatch }) => {
  try {
    dispatch(setExporting(true));
    const response = await post('export', params);
    return response.data;
  } catch (error) {
    if (!isAuthError(error, dispatch)) {
      throw error;
    }
  } finally {
    dispatch(setExporting(false));
  }
};
